import wlmLogin from './main.vue';

export default {
  install(Vue) {
    Vue.component(wlmLogin.name, wlmLogin);
  },
};
